//! @ngInject
export function ClockinClockoutService($http, Consts, wildcard, DatabaseApi) { return {
    /**
   * link a clock records that's missing visit instance / patient id
   */
  linkCalls: (
    agencyId, agencyMemberId, records
  ) => {
    const url =
      Consts.api +
      "agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/link";
    return $http.patch(wildcard(url, agencyId, agencyMemberId), {
      records: records
    });
  },
  
    /**
     * Reject a clock record that's missing visit instance / patient id
     */
    linkCall: (
      recordId,
      { agencyId, agencyMemberId, patientId, visitInstanceId }
    ) => {
      const url =
        Consts.api +
        "agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/:clockInClockoutRecordId/link";
      return $http.patch(wildcard(url, agencyId, agencyMemberId, recordId), {
        patientId: patientId,
        visitInstanceId: visitInstanceId
      });
    },

  /**
   * Fetch candidate visits to link an unmatched call against, for a coordinator-
   * chosen caregiver (and optionally patient). Used when the call has no
   * system-suggested potential links (e.g. unknown caregiver).
   */
  getCandidateVisits: (recordId, { agencyId, agencyMemberId, caregiverId, patientId }) => {
    const url =
      Consts.api +
      "agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/:clockInClockoutRecordId/candidate_visits";
    return $http.get(wildcard(url, agencyId, agencyMemberId, recordId), {
      params: { caregiverId: caregiverId, patientId: patientId }
    });
  },

  /**
   * Ask whether linking a clock-OUT to this visit has to record duties (the
   * visit's office has "require IVR duties" on), and get the duties that
   * visit's plan of care offers.
   */
  getVisitDutyRequirement: (recordId, { agencyId, agencyMemberId, visitInstanceId }) => {
    const url =
      Consts.api +
      "agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/:clockInClockoutRecordId/visit_duty_requirement";
    return $http.get(wildcard(url, agencyId, agencyMemberId, recordId), {
      params: { visitInstanceId: visitInstanceId }
    });
  },

  /**
   * Fetch a short-lived signed URL to play back a call's recording.
   */
  getRecordingSignedUrl: (recordId, { agencyId, agencyMemberId }) => {
    const url =
      Consts.api +
      "agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/:clockInClockoutRecordId/recording";
    return $http.get(wildcard(url, agencyId, agencyMemberId, recordId));
  },

  /**
   * Fetch plan-of-care duty catalogs (code -> name) for a set of offices, so the
   * table can map a record's stored duty codes to their names.
   */
  getOfficeDutyCodes: ({ agencyId, agencyMemberId, officeIds }) => {
    const url =
      Consts.api +
      "agencies/:agencyId/agency_members/:agencyMemberId/offices/duty_codes";
    return $http.post(wildcard(url, agencyId, agencyMemberId), { officeIds: officeIds });
  },

  /**
   * Reject a clock records that's missing visit instance / patient id
   */
  rejectCalls: ({ records, agencyId, agencyMemberId }) => {
    const url =
      Consts.api +
      "agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/reject";
    return $http.patch(
      wildcard(url, agencyId, agencyMemberId), {
      records: records
    });
  },

  /**
   * Restore a clock records from Rejected table
   */
  restoreCalls: ({ records, agencyId, agencyMemberId }) => {
    const url =
      Consts.api +
      "agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/restore";
    return $http.patch(
      wildcard(url, agencyId, agencyMemberId), {
      records: records
    });
    },

    /**
     * Update a clock record
     */
    update: (recordId, { agencyId, agencyMemberId, data }) => {
        const url = "agencies/:agencyId/agency_members/:agencyMemberId/clockin_clockout_records/:clockInClockoutRecordId"
            .replace(":agencyId", agencyId)
            .replace(":agencyMemberId", agencyMemberId)
            .replace(":clockInClockoutRecordId", recordId);

        return DatabaseApi.put(url, data);
    },


    formatReason: ({ record, reason }) => {
        switch (reason) {  
            case "MISSING_PATIENT":
                return "Missing patient";
            case "MISSING_VISIT":
                return "Missing visit";
            case "DUPLICATE_CALL":
                return "Duplicate call";
            case "BLOCKED_CALLER_ID":
                return "Blocked caller ID";
            case "CALL_FROM_CAREGIVER_PHONE":
                return "Call from caregiver phone";
            case "CLOCK_OUTSIDE_OF_RANGE":
                return "Clock outside of range";
            case "CLOCK_OUT_TOO_SOON":
                return "Clock out too soon";
            case "PHONE_WITHOUT_EVV_LOCATION":
                return "Phone without EVV location";
            case "UNLINKED_MANUALLY":
                return "Unlinked manually";
            case "MISSING_CAREGIVER":
                return "Missing caregiver";
            default:
                if (!record) {
                    return status;
                }

                if (!record.patient.exists && !record.visitInstance.exists) {
                    return "Missing Patient & Visit";
                }

                if (!record.patient.exists) {
                    return "Missing Patient";
                }

                if (!record.visitInstance.exists) {
                    return "Missing Visit";
                }

                return reason;
        }
    }
  } };
